import {
  KnownDeliveryState,
  KnownOrderStatus,
  KnownProjectDtoDisplayWorkflowTypesItem
} from '@groundfloor-platform/mgmt-service-g-sdk';
import { createPath, Paths, ProjectPathParams } from '../../../app/router/app.router';
import { useDisplayWorkflowTypes } from '../../../hooks/use-display-workflow-types.hook';

export function usePathFromStatusCountCard(
  params: ProjectPathParams<Paths.dashboard>,
  status: KnownOrderStatus | KnownDeliveryState
) {
  const [workflowTypes] = useDisplayWorkflowTypes(params.projectID);

  const deliveriesListPathBase = createPath(Paths.deliveries, { projectID: params.shortcode || params.projectID });
  const deliveriesListPathFull = `${deliveriesListPathBase}?state=${status}`;

  const ordersListPathBase = createPath(Paths.orders, { projectID: params.shortcode || params.projectID });
  const ordersListPathFull = `${ordersListPathBase}?status=${status}`;

  if (
    !workflowTypes.includes(KnownProjectDtoDisplayWorkflowTypesItem.WorkflowRetail) &&
    status !== KnownOrderStatus.Booked
  ) {
    // This shouldn't happen. If there are no projects in scope with the Retail workflow then we
    // shouldn't be displaying the 'orders' status count grid.
    // But it's safer not to assume that this will be true and handle it just in case
    return deliveriesListPathFull;
  }

  if (workflowTypes.length > 1 && status !== KnownOrderStatus.Booked) {
    // If there are any workflows other than Retail in scope, then we link to the
    // Deliveries list page for all statuses except Booked
    return deliveriesListPathFull;
  }

  // Finally, either only the Retail workflow is in scope or this is a Booked status,
  // in which cases we link to the Orders list page
  return ordersListPathFull;
}
